module.exports = __webpack_public_path__ + "img/16.4e8a5104.jpg";